import DOMPurify, { type Config as IDOMPurifyConfig } from 'dompurify';

import { getWindow } from '@r-client/shared/util/core';

import { ISafeHTMLProps, SafeHTML } from './safe-html';

type IDangerousHTMLProps = Omit<ISafeHTMLProps, 'sanitizedHtml'> & {
  html: string;
  addAllowedAttributes?: string[];
};

const window = getWindow();
const purify = DOMPurify(window);

// Use when the HTML is not safe for the client to display.
// when it is not sanitized by server-side
// currently this component works only with client-side rendering
export const DangerousHTML = ({
  html,
  addAllowedAttributes = [],
  ...restProps
}: IDangerousHTMLProps) => {
  const sanitizeOptions: IDOMPurifyConfig = {};
  sanitizeOptions['ADD_ATTR'] = addAllowedAttributes;

  return (
    <SafeHTML
      {...restProps}
      sanitizedHtml={purify.sanitize(html, sanitizeOptions).toString()}
    />
  );
};
